import { render, staticRenderFns } from "./ServiceBack.vue?vue&type=template&id=67192ba6&"
import script from "./ServiceBack.vue?vue&type=script&lang=js&"
export * from "./ServiceBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports